var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30_314)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0.75C7.08745 0.75 2.92495 3.8625 1.38745 8.25H22.6124C21.0749 3.8625 16.9124 0.75 12 0.75Z",
    fill: "#C94747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 23.25C16.9124 23.25 21.0749 20.1375 22.6124 15.75H1.38745C2.92495 20.1375 7.08745 23.25 12 23.25Z",
    fill: "#699635"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.3875 8.25C0.975 9.4125 0.75 10.6875 0.75 12C0.75 13.3125 0.975 14.5875 1.3875 15.75H22.6125C23.025 14.5875 23.25 13.3125 23.25 12C23.25 10.6875 23.025 9.4125 22.6125 8.25H1.3875Z",
    fill: "#FFCE31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 13.9875L14.325 15.75L13.425 12.9L15.75 11.0625H12.9L12 8.25L11.1375 11.0625H8.25L10.575 12.9L9.675 15.75L12 13.9875Z",
    fill: "#3E4347"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30_314"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGh);
export default __webpack_public_path__ + "static/media/gh.3e373ba6a2b652c46febec12357e1f6e.svg";
export { ForwardRef as ReactComponent };